"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import type { TUseFiltersStore } from "./filters.config";
import { filtersDispatch } from "./filters.store";
import { parseFilters, updateSearchParams } from "./filters.utils";
import { useFiltersStore } from "./useFiltersStore";

export const useFiltersUrlSync = (): TUseFiltersStore => {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const searchParamsString = searchParams.toString();
  const isHydratingFromSearchParams = useRef(false);
  const filtersStore = useFiltersStore();

  useEffect(() => {
    isHydratingFromSearchParams.current = true;
    filtersDispatch.hydrateFilters(
      parseFilters(new URLSearchParams(searchParamsString)),
    );
  }, [ searchParamsString ]);

  useEffect(() => {
    if (isHydratingFromSearchParams.current) {
      isHydratingFromSearchParams.current = false;
      return;
    }

    const nextSearchParams = new URLSearchParams(searchParamsString);
    updateSearchParams(nextSearchParams, filtersStore.filters);
    const nextSearchParamsString = nextSearchParams.toString();

    if (nextSearchParamsString === searchParamsString) {
      return;
    }

    const nextUrl = nextSearchParamsString
      ? `${pathname}?${nextSearchParamsString}`
      : pathname;

    router.replace(nextUrl, { scroll: false });
  }, [ filtersStore.filters, pathname, router, searchParamsString ]);

  return filtersStore;
};
